<fieldset *ngIf="isVisible()" class="custom-field-values" [class.page-variant]="variant === 'page'">
  <legend>Custom Field Values</legend>
  <table aria-label="Custom Field Values">
    <thead><tr><th>Field Name</th><th>Field Value</th></tr></thead>
    <tbody><tr *ngFor="let item of visibleValues"><td>{{ item.displayLabel }}</td><td>{{ formatValue(item.value, item.displayLabel) }}</td></tr></tbody>
  </table>
</fieldset>
